module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAPtJREFUSIm1lmEOgyAMhR/L7jVupp4MPdnbD0BLbFkxjISItHwPilADOoVkLM2lPOv7XipCCFuPYYJJJrYllbootuU3tYWfA8UqLN/FLSScUw/cGWeLCCf/cm3GfXJV/ilccNJNZMbsBavuYZKdbrjHtwlVN279waaIWMUl4IEPiuQwlU1JluNTkcp9Ix//VQPguhp6ZSV5hBB2xRZftaEYDwe8lo/SlwX/HaLzYMyEF59sbz6pefCoCUw/aLIjjazCA28mQe3+eC5AdU9HQ2XA+/sjHIaE2KZYd1Yjx1Om6ftLiGwTflJsKjx4hEozov1tAYANAIx7CADwBSx4VYzoTypXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/进入.png
// module id = cbE2
// module chunks = 2